import { StepId } from "@/components/features/ToDos/DataVerification/Company/constants";
import { WizardStep } from "@/components/organisms";
import { NavigationButtonTranslations } from "@/components/organisms/FooterFlowButtons/FooterFlowButtons";
import { fakeI18n } from "@/i18n";

export const getNavigationLabels = ({ step }: { step: WizardStep }): NavigationButtonTranslations =>
    step.stepId === StepId.Summary
        ? {
              next: fakeI18n.t("Common.Confirm"),
          }
        : null;
